import { render, staticRenderFns } from "./AddToList.vue?vue&type=template&id=05ec5736&scoped=true&"
import script from "./AddToList.vue?vue&type=script&lang=js&"
export * from "./AddToList.vue?vue&type=script&lang=js&"
import style0 from "./AddToList.vue?vue&type=style&index=0&id=05ec5736&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ec5736",
  null
  
)

export default component.exports